import { render, staticRenderFns } from "./xflist_leader.vue?vue&type=template&id=88c9bedc&scoped=true&"
import script from "./xflist_leader.vue?vue&type=script&lang=js&"
export * from "./xflist_leader.vue?vue&type=script&lang=js&"
import style0 from "./xflist_leader.vue?vue&type=style&index=0&id=88c9bedc&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c9bedc",
  null
  
)

export default component.exports